<template>
<div>
<navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x" v-if="user">
    <h2 class="shadow">My Account</h2>

    <h4>Status: <span>{{user && user.premium ? 'Premium' : 'Free'}}</span></h4>
    <router-link v-if="!user || !user.premium" :to="{path: '/buy'}">Buy Picks!</router-link>
    <p><router-link :to="{path: '/changepassword'}">Change Password</router-link></p>
    <div class="input">
      <p class="text_form">
        Email:
      </p>
      <input type="text" name="email" class="contact_form" v-model="user.email"/>
    </div>
      Pick Notifications:
      <form name="form1" style="padding-left:2px;display:inline">
      <input type="radio" name="contactMethod" :value="0" v-model="user.contact_method" @change="methodChanged()"/> None
      <input type="radio" name="contactMethod" :value="1" v-model="user.contact_method" @change="methodChanged()"/> Email
      <input type="radio" name="contactMethod" :value="2" v-model="user.contact_method" @change="methodChanged()"/> Text Message
      <select v-model="phone" name="phones" id="phoneList" v-if="user.contact_method === 2">
          <option v-for="p in phoneOpts" :value="p">{{ p.key }}</option>
      </select>
      <input type='text' name="contact_email" :placeholder="user.contact_method === 1 ? 'Enter Contact Email' : 'Enter Contact Phone'" id="contactEmail" v-model="user.contact_email" v-if="user.contact_method !== 0" />
      <br />
      <br />
      <button class="button" style="width:100%;" @click.prevent="save()">Save</button>
      </form>
  </div>
</div>
</template>

<script>
import Nav from '../components/Nav'
import AuthRepository from '../data/auth.repository'
import _ from 'lodash'
export default {
  components: {
    'navigation': Nav
  },
  computed: {
    user () {
      return this.$store.state.currentUser
    }
  },
  data () {
    return {
      phone: {},
      phoneOpts: [
        {key: 'Select Carrier', value: 0},
        // {key: 'AT&T', value: 1},
        {key: 'Verizon', value: 2},
        {key: 'T-Mobile', value: 3},
        {key: 'Sprint', value: 4},
        {key: 'U.S. Cellular', value: 5},
        {key: 'Virgin Mobile', value: 6},
        {key: 'Tracfone', value: 7},
        {key: 'Metro PCS', value: 8},
        {key: 'Boost Mobile', value: 9},
        {key: 'Cricket', value: 10},
        {key: 'Nextel', value: 11},
        {key: 'Alltel', value: 12},
        {key: 'Ptel', value: 13},
        {key: 'Suncom', value: 14},
        {key: 'Qwest', value: 15}
      ]
    }
  },
  methods: {
    save () {
      this.user.contact_phone = this.phone.value
      if (!this.user.contact_phone) this.user.contact_phone = 0
      AuthRepository.save(this.user).then((result) => {
        this.$store.dispatch('getStoredUser')
        this.$router.push('/')
      }).catch(() => console.log('An error occurred'))
    },
    methodChanged () {
      this.user.contact_email = ''
    }
  },
  mounted () {
    if (!this.$store.state.currentUser.contact_phone || this.$store.state.currentUser.contact_phone === 0) {
      this.phone = this.phoneOpts[0]
    } else if (this.$store.state.currentUser.contact_phone) {
      this.phone = _.find(this.phoneOpts, ['value', this.$store.state.currentUser.contact_phone])
    }
  },
  metaInfo: {
    title: 'My Account'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// MyAccount.vue?91d5225a